import { tableGridProgress } from '../components/steps/TableGridStep';
import { equipmentInspectionProgress } from '../components/steps/EquipmentInspectionStep';

/**
 * Whether a saved answer is complete enough to count. A table or inspection
 * is saved on the first edit, so being saved alone doesn't mean it's done:
 * tables need every answer cell, inspections every device fully inspected.
 * The backend applies the same rule when completing the procedure.
 */
export function isStepValueComplete(step, value) {
  if (step.step_type === 'TABLE_GRID') {
    const { filled, total } = tableGridProgress(step, value);
    return filled === total;
  }
  if (step.step_type === 'EQUIPMENT_INSPECTION') {
    const { filled, total } = equipmentInspectionProgress(step, value);
    return total > 0 && filled === total;
  }
  return true;
}
